import { Col, Form, FormInstance, Row } from 'antd';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import DatePickerWrap from '../../../../components/DatePickerWrap';
import { MONTH_YEAR_FORMAT, MONTH_YEAR_FORMAT_JP } from '../../../../constants/common';
import dayjs from 'dayjs';

interface IProps {
  form: FormInstance;
}

const FormExportTimekeeping: FC<IProps> = (props) => {
  const { form } = props;
  const intl = useIntl();

  return (
    <Form layout="vertical" form={form} name="form_in_modal" clearOnDestroy>
      <div className="form-staff">
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item
              name="month"
              className="custom-label"
              label={intl.formatMessage({ id: 'account.timekeepingStatistics.export.modal.month.input' })}
              rules={[{ required: true, message: intl.formatMessage({ id: 'common.required' }) }]}
              initialValue={dayjs().startOf('month')}
            >
              <DatePickerWrap maxLength={255} className="width-full" picker="month" format={MONTH_YEAR_FORMAT_JP} />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default FormExportTimekeeping;
